// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__BrwOG","input":"Toggle_input__73AjG","slider":"Toggle_slider__b7LB1","sliderActive":"Toggle_sliderActive__5dz9R","sliderThumb":"Toggle_sliderThumb__gLMSz"};